import classnames from 'classnames'
import * as React from 'react'

import { Heading } from '../../components/typography'

interface Props {
  children: React.ReactNode
  className?: string
}

export function WidgetHeader({ children, className }: Props) {
  return (
    // m-0 & text-base are necessary to override default H* styles on old design
    <Heading level={4} className={classnames('m-0 text-base text-muted', className)}>
      {children}
    </Heading>
  )
}
